import { SvgIcon, SvgIconProps } from 'ui/icons';
import { getColor } from 'ui/icons/utils';
import { colors } from 'ui/theme';

export const Trophy = ({
  height = 12,
  width = 11,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 11 12" {...props}>
    <path
      d="M5.49878 7.17712V11.1057"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="0.785714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.53442 11.1061H7.463"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="0.785714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.74874 4.81998C2.12359 4.81998 1.52404 4.57164 1.08199 4.12959C0.639943 3.68754 0.391602 3.08799 0.391602 2.46284V1.67712H3.1416V4.81998H2.74874Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="0.785714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.24894 4.81998C8.87409 4.81998 9.47364 4.57164 9.91569 4.12959C10.3577 3.68754 10.6061 3.08799 10.6061 2.46284V1.67712H7.85608V4.81998H8.24894Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="0.785714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.85589 4.82017C7.85589 5.44533 7.60755 6.04487 7.1655 6.48692C6.72345 6.92897 6.1239 7.17732 5.49874 7.17732C4.87359 7.17732 4.27404 6.92897 3.83199 6.48692C3.38994 6.04487 3.1416 5.44533 3.1416 4.82017V0.891602H7.85589V4.82017Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="0.785714"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
